import { render, staticRenderFns } from "./OnboardingWaitlist.vue?vue&type=template&id=f309452e&"
import script from "./OnboardingWaitlist.vue?vue&type=script&lang=js&"
export * from "./OnboardingWaitlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports